// MongoDB-backed session API — used when user is logged in
// Falls back to localStorage (sessions.js) when logged out or on auth failure

const API_BASE = import.meta.env.VITE_API_URL || 'https://ai-sexdoc-backend.onrender.com';

function getToken() {
  return localStorage.getItem('sera.jwt');
}

function authHeaders() {
  const token = getToken();
  const h = { 'Content-Type': 'application/json' };
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

// When the backend rejects our token (401), the stored login is invalid or
// expired. Clear it and let the app fall back to localStorage instead of
// retrying forever and flooding the console with errors.
function handleUnauthorized() {
  localStorage.removeItem('sera.jwt');
  localStorage.removeItem('sera.user');
  localStorage.removeItem('sera.refresh');
  // Let AuthContext update its React state (see AuthProvider).
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('sera:auth-expired'));
  }
}

async function authFetch(url, opts = {}) {
  const res = await fetch(url, { ...opts, headers: { ...authHeaders(), ...(opts.headers || {}) } });
  if (res.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized');
  }
  return res;
}

export async function dbGetSessions() {
  const res = await authFetch(`${API_BASE}/sessions`);
  if (!res.ok) throw new Error('Failed to fetch sessions');
  const sessions = await res.json();
  // Normalize to same shape as localStorage sessions
  return sessions.map(s => ({
    id: s._id,
    title: s.title,
    createdAt: new Date(s.createdAt).getTime(),
    updatedAt: new Date(s.updatedAt).getTime(),
    messages: [],
  }));
}

export async function dbCreateSession(title) {
  const res = await authFetch(`${API_BASE}/sessions`, {
    method: 'POST',
    body: JSON.stringify({ title: title || 'New chat' }),
  });
  if (!res.ok) throw new Error('Failed to create session');
  const s = await res.json();
  return { id: s._id || s.id, title: s.title, createdAt: new Date(s.createdAt).getTime(), updatedAt: new Date(s.updatedAt).getTime(), messages: [] };
}

export async function dbGetSession(id) {
  const res = await authFetch(`${API_BASE}/sessions/${id}`);
  if (!res.ok) throw new Error('Failed to fetch session');
  const s = await res.json();
  return {
    id: s._id,
    title: s.title,
    createdAt: new Date(s.createdAt).getTime(),
    updatedAt: new Date(s.updatedAt).getTime(),
    messages: s.messages || [],
  };
}

export async function dbRenameSession(id, title) {
  await authFetch(`${API_BASE}/sessions/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ title }),
  });
}

export async function dbDeleteSession(id) {
  await authFetch(`${API_BASE}/sessions/${id}`, {
    method: 'DELETE',
  });
}

export async function dbSaveMessages(id, messages) {
  await authFetch(`${API_BASE}/sessions/${id}/messages/bulk`, {
    method: 'POST',
    body: JSON.stringify({ messages }),
  });
}
